import * as React from 'react';
import { FONT_COLOR, COLOR_A, COLOR_B } from './CONSTANTS';
import SourceDisplay from './SourceDisplay';
import TouchSlider from './TouchSlider';

const SourceLoopView = ({
	clips,
	setUrl,
	buffer,
	sourceStart,
	sourceEnd,
	setSourceStart,
	setSourceEnd,
	setSourceOffset,
	loadProgress,
	clipName,
}) => {
	return (
		<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<div style={{ height: '13%', width: '100%' }}>
				<h2 style={{zIndex:4,color:FONT_COLOR}}>{clipName}</h2>
			</div>
			<div style={{ width: '100%', height: '57%', margin: 'auto' }}>
				<SourceDisplay
					loadProgress={loadProgress}
					buffer={buffer}
					sourceStart={sourceStart}
					sourceEnd={sourceEnd}
				/>
			</div>

			<div style={{ height: '15%' }}>
				<TouchSlider
					pushedValue={sourceStart + 0.001}
					setValue={setSourceStart}
					min={0}
					max={1}
					label={'start'}
				/>
			</div>

			<div style={{ height: '15%' }}>
				<TouchSlider pushedValue={sourceEnd} setValue={setSourceEnd} min={0} max={1} label={'end'} />
			</div>
		</div>
	);
};

export default SourceLoopView;
